import React, { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { ChevronDown } from "@app/components/common/icons";
import { ModalState } from "@app/enums/modal";
import { useModal } from "@app/hooks";

export const Subscribe: FC = () => {
  const { t } = useTranslation("footer");
  const { onChangeModalState } = useModal();

  return (
    <div className={"bg-[#BBDDFE]"}>
      <div
        className={classNames(
          "grod-cols-1 grid gap-7.5 px-5 py-20 text-base-content",
          "lg:grid-cols-2 lg:items-center lg:gap-5 lg:px-16",
          "xl:mx-auto xl:max-w-container-wide xl:px-24",
        )}
      >
        <p className="flex-1 text-extra-large lg:pr-7">
          {t("subscribe_title")}
        </p>
        <button
          type="button"
          onClick={() => onChangeModalState(ModalState.SUBSCRIBE)}
          className="group flex flex-1 items-center justify-between border-b border-solid border-base-content py-2 text-start text-small-tall"
        >
          <span
            className={classNames("duration-300", "group-hover:text-grey-dark")}
          >
            {t("subscribe_link")}
          </span>
          <ChevronDown
            className={classNames(
              "h-2.5 -rotate-90 text-base-content duration-300",
              "group-hover:text-grey-dark",
            )}
          />
        </button>
      </div>
    </div>
  );
};
